module.exports = __webpack_public_path__ + "static/media/icon_bq_cd_01ml.f75be4a1.svg";